/**
 * LA INSIGNIA DE ESTADO (CONTRATO-VISTA-PANEL-T1, tema grupo 2; regla de dos: 28 archivos la armaban a mano).
 *
 * Antes cada vista escribia `<span class="status-badge" style="background:${color}22;color:${color}">`: el fondo era
 * el color con "22" pegado al final (13 % de opacidad). Ese sufijo solo funciona con un #hex, asi que la vista no podia
 * tomar el color del tema (var(--...)). Aqui el fondo lo pinta .nx-insignia::before con currentColor y opacidad, en
 * artifacts.css: el color puede ser una variable del tema o un #hex, y se ve igual que antes (0x22 / 255 = 13 %).
 * Sin color-mix(): las tabletas viejas de los negocios no lo tienen.
 *
 * El texto llega YA escapado por quien llama (como antes); el color sale del codigo, nunca del usuario.
 *
 * @module presentation/shared/insignia
 */

/** Los colores de estado del tema, por nombre de uso. */
export const COLOR_ESTADO = {
  ok: 'var(--accent-green)',
  alerta: 'var(--accent-yellow)',
  error: 'var(--accent-red)',
  apagado: 'var(--text-muted)'
};

/**
 * @param {string} texto     ya escapado
 * @param {string} color     var(--...) del tema (o un #hex mientras la vista no migre)
 * @param {string} [atributos] atributos extra ya armados, p. ej. 'data-estado-negocio'
 * @param {string} [clase]   la forma de la insignia (tema grupo 5: 'proj-badge' en Proyectos); el fondo siempre es el de .nx-insignia
 */
export function insigniaHtml(texto, color, atributos = '', clase = 'status-badge') {
  const extra = atributos ? ` ${atributos}` : '';
  return `<span class="${clase} nx-insignia"${extra} style="color:${color}">${texto}</span>`;
}
